<template>
    <form class="new-message-form" @submit.prevent="send()">
        <v-select
                v-model="form.recipient"
                :options="users"
                @search="findUsers"
                label="name"
                :filterable="false"
                :getOptionLabel="recipientLabel"
                placeholder="Adresāts...">
            <span slot="no-options">Nav rezultātu. Lūdzu ieraksti vāru, uzvārdu vai skolu.</span>
        </v-select>
        <input type="text" name="subject" id="subject" placeholder="Tēma" v-model="form.subject"/>
        <textarea id="message" name="message" v-model="form.message" rows="4"></textarea>
        <button type="submit" class="button success" :disabled="form.message === ''">Sūtīt</button>
    </form>
</template>

<script>
    //import Multiselect from 'vue-multiselect'
    import users from '../../api/users'
    import VueSelect from 'vue-select'
    import { Form } from '../../modules/forms/Form'
    import messages from '../../api/messages'
    import { mapGetters } from 'vuex'

    export default {
        name: "message-form",

        props: {
            recipient: Object
        },

        created() {
            this.form.recipient = this.recipient;
        },

        data() {
            return {
                form: new Form({
                    message: null,
                    recipient: null,
                    subject: null,
                }),

                users: [],
            }
        },

        methods: {

            async findUsers(query, loading) {
                loading(true);
                this.users = await users.get({ query })
                    .then(response => response.data.data.filter(user => user.id !== this.user.id));
                loading(false)
            },

            async send() {
                const result = await this.$validator.validateAll();

                if (result) {
                    const data = this.form.data()

                    data.recipient_id = data.recipient.id
                    delete data['recipient'];

                    messages.send(data).then(response => {
                        this.form.reset();
                        this.$emit('sent', response.data);
                    })
                }
            },

            recipientLabel(user) {
                return user.name + ' (' + user.school.title + ')'
            },
        },

        computed: {
            ...mapGetters(['user'])
        },

        components: {
            'v-select': VueSelect
        }
    }
</script>

<style lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .new-message-form {

    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/inbox/MessageForm.vue